// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import punycode from 'punycode';

const toPunycode = domain => punycode.toASCII(domain);

export { toPunycode };
